import React from "react";
import { SiteVariablesPrepared } from "@fluentui/react-northstar";
import { IChartData } from "../ChartTypes";
import { PieChart } from "./Pie";
import { IOutlabeledChartOptions } from "../IOutlabeledChartOptions";

export const DoughnutChart = ({
    title,
    data,
    siteVariables,
    tooltipHideFooter,
    presentsMoney,
    legendOnTheRightSide,
    hideLegend,
    chartContainerMinHeight,
    outlabeledChartOptions,
}: {
    title: string;
    data: IChartData;
    siteVariables: SiteVariablesPrepared;
    tooltipHideFooter?: boolean;
    presentsMoney?: boolean;
    legendOnTheRightSide?: boolean;
    hideLegend?: boolean;
    chartContainerMinHeight?: string;
    outlabeledChartOptions?: IOutlabeledChartOptions;
}) => (
    <PieChart
        {...{
            title,
            data,
            siteVariables,
            cutoutPercentage: 70,
            tooltipHideFooter,
            presentsMoney: presentsMoney,
            legendOnTheRightSide: legendOnTheRightSide,
            hideLegend: hideLegend,
            chartContainerMinHeight: chartContainerMinHeight,
            outlabeledChartOptions: outlabeledChartOptions,
        }}
    />
);
